import React from "react";
import { LoaderSVG } from "../../assets/icons";

const Loader = () => {
  return <img src={LoaderSVG} />;
};

export default Loader;
